import React, { useState } from 'react';
import { NavLink, useOutletContext } from 'react-router-dom';
import { Button } from 'reactstrap';
import GenerateDefaultUsersModal from './GenerateDefaultUsersModal';
import UserCard from '../../../components/UserCard';

const UsersTab = () => {
    const { organization, organizationUsers, orgUserStatus, user, bacView } = useOutletContext();
    const [defaultsModal, setDefaultsModal] = useState(false);

    return (
        <div className="organization-users">
            <div className="d-flex justify-content-between align-items-center flex-wrap gap-2 mb-3">
                <h2 className="mb-0">Organization users</h2>
                {bacView && (
                    <Button color="primary" outline onClick={() => setDefaultsModal(true)}>
                        <span className="fas fa-user-plus me-2"/>
                        Generate default users
                    </Button>
                )}
            </div>

            {user.role === 'site-admin' && (
                <NavLink to={`/users/new?parentOrganization=${organization._id}`} className="text-decoration-none">
                    <span className="fas fa-plus me-2"/> Create a user for this organization
                </NavLink>
            )}

            {orgUserStatus === 'success' && organizationUsers.map(user => (
                <NavLink
                    to={`/users/${user._id}`}
                    state={{ from: 'organization', orgId: organization._id, orgName: organization.name }}
                    key={user._id}
                    className="text-decoration-none"
                >
                    <UserCard user={user}></UserCard>
                </NavLink>
            ))}

            {organizationUsers.length === 0 && (
                <div>No users from this organization</div>
            )}

            {bacView && (
                <GenerateDefaultUsersModal
                    isOpen={defaultsModal}
                    toggle={() => setDefaultsModal(v => !v)}
                    organization={organization}
                />
            )}
        </div>
    );
};

export default UsersTab;
